import { FormattedMessage } from 'react-intl';
import Switch from 'react-switch';
import { colors } from '../globalStyles';
import { ToggleBox, ToggleSmall } from '../components/styled';

interface Props {
  handleChange: () => void;
  checked: boolean;
  contentLabel: string;
}

export const Toggle = (props: Props) => (
  <ToggleBox>
    <ToggleSmall>
      <FormattedMessage id={props.contentLabel} />
    </ToggleSmall>
    <Switch onColor={colors.green} width={50} height={25} onChange={props.handleChange} checked={props.checked} />
  </ToggleBox>
);
